// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-31P9LFbl","box":"box-tWoIWBiH","footer":"footer-kR_CB7iA"};